import { useEffect, useState } from "react";
import { format, parse } from "date-fns";
import { Grid, Typography} from "@mui/material";



export const PaymentCard = ({
  eventNames,
  invoiceDueDates,
  invoiceAmountsDue,
}) => {

  const [amountDue, setAmountDue] = useState();
  const [dueBy, setDueBy] = useState();

  useEffect(() => {
    if (invoiceAmountsDue) {
      setAmountDue(invoiceAmountsDue);
    }
    if (invoiceDueDates) {
      setDueBy(invoiceDueDates);
    }

  }, [invoiceAmountsDue]);
    
  let currentEvent = "";

  const parseDate = (timeStamp) => {
    let date = new Date(timeStamp * 1000).toISOString();
    date = date.split("T")[0];
    
    try {
      if (date !== null && date !== undefined) {
        date = parse(date, "yyyy-MM-dd", new Date());
        date = format(date, "MMM do, yyyy");
        return date;
      } else {
        return "Error fetching";
      }
    } catch (err) {
      console.log(err);
      return "Error occured";
    }
};

  const parseAmount = (amount) => {
    if (amount !== null && amount !== undefined) {
      amount = parseInt(amount);

      return amount / 100;
    }
  };

  return (
    <div className="event_list">
        <Grid container spacing={1}>
            {amountDue && 
            (amountDue ?? [])?.map((amount, idx) => {
              if (eventNames[idx] != currentEvent) {
                currentEvent = eventNames[idx];
                return(
                  <div key={idx}>
                    <h4><u>{eventNames[idx]}</u></h4>
                    <Typography>${parseAmount(amount)} due on {parseDate(dueBy[idx])}</Typography>
                  </div>
                );
              }
              else {
                return(
                  <div key={idx}>
                  <Typography>${parseAmount(amount)} due on {parseDate(dueBy[idx])}</Typography>
                  </div>
                );
              }
            })}
        </Grid>
    </div>
  );
};

export default PaymentCard;
